import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_MESSAGE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'SendMessage',
        name: 'Send Message',
        icon: 'fas fa-envelope',
        route: { name: ROUTE_NAME_MESSAGE.SEND }
    }
]);

export default registerRouteForModule(router);
